import React, { useState } from "react";
import { useSelector } from "react-redux";
import "../categories.css";
import CategoryCard from "./CategoryCard";
import ActivitySignalBanner from "../components/ActivitySignalBanner";
import useDynamicDimension from "../services/useDynamicDimension";


const HomeCategories = ({ handleClick }) => {
  const categories = useSelector(state => state?.categories?.data);
  const [imageError, setImageError] = useState(false);
  const screenSize  = useDynamicDimension();

  return (
    <div className="categories-container col-md-6 offset-md-3">
      {/* <div>{screenSize?.dynamicWidth}</div> */}
      {categories?.map((category, index) => {
        if (category?.name === 'user') return null;
        return (<React.Fragment key={index}>
          <CategoryCard  category={category} handleClick={handleClick} idx={index} />
          {/* show bannerafter 1st row */}
           {index === screenSize?.dynamicCurrentGrid && (
            <ActivitySignalBanner showBannerIdx={1}/>
          )}

          {/* show bannerafter 4th for 3 grid table or after 12th row for 2 grid table */}
          {index === 12 && (screenSize?.dynamicCurrentGrid * 3 === 9 || screenSize?.dynamicCurrentGrid * 4 === 8) && (
            <ActivitySignalBanner showBannerIdx={2}/>
          )}

          {/* sample banner */}
          {/* {index === 100 && (
            <div className="lp-activity-banner">
              <div className="lp-activity-banner__icon">
                <i className="fa fa-bolt" />
              </div>
              <div className="lp-activity-banner__text">
                <p className="lp-activity-banner__title">AC Technician booked nearby</p>
                <p className="lp-activity-banner__sub">Andheri West · 2 hours ago</p>
              </div>
              <span className="lp-activity-banner__live">Live</span>
            </div>
          )} */}

        </React.Fragment>)
      })}
    </div>
  );
}

export default HomeCategories;